 
const providerType = {
    GOOGLE: 'g',
    OKTA: 'o'
}

export default providerType